import axios from "axios";
import getApiUrl from "src/utils/get-api-url";

const apiUrl = getApiUrl();

/**
 * Create a new fit between deallocation and need.
 * - Case 1 (fit in deallocation's page): 1 deallocation -> 1 need.
 * - Case 2 (fit in need's page): up to 3 deallocations -> 1 need.
 * 
 * @param {string[]} deallocationIds
 * @param {string[]} needsId
 * @returns {Promise<Object>}
 */
export function requestFit(deallocationIds, needsId) {
  return axios.post(`${apiUrl}/fit`, { deallocationIds, needsId })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error('Error in requestFit:', error);
      throw error.response?.data || error;
    });
}

/**
 * Update fit to be a match.
 * 
 * @param {Object} fitMatch
 * @param {string} fitMatch.deallocationId
 * @param {string} fitMatch.match - its value is always 'Y'
 * @returns {Promise<Object>}
 */
export function fitMatchPut(fitMatch) {
  return axios.put(`${apiUrl}/fit`, fitMatch)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error('Error in fitMatchPut:', error);
      throw error.response?.data || error;
    });
}

/**
 * Deactivate existing fit (only fit, not a match).
 *
 * @param {string} fitId
 * @param {string} cancelCategory
 * @param {string} [cancelSubcategory]
 * @returns {Promise<Object>}
 */
export function cancelFit(fitId, cancelCategory, cancelSubcategory) {
    return axios.patch(`${apiUrl}/fit/cancel/${fitId}`, { cancelCategory, cancelSubcategory });
}

/**
 * Rollback (cancel) an existing match.
 * 
 * @param {Object} fitMatch 
 * @param {string} fitMatch.deallocationId
 * @param {string} fitMatch.needId
 * @param {string} fitMatch.match - its value is always 'N'
 * @param {string} fitMatch.match - its value is always 'N'
 * @param {string} [fitMatch.rollbackDescription]
 * @returns {Promise<Object>}
 */
export function rollbackMatch(fitMatch) {
    /**NOTE - fitMatch: {
                deallocationId,
                needId,
                match: 'N',
                active: 'N',
                rollbackDescription: description,
            } */
    return axios.put(`${apiUrl}/fit/rollback`, fitMatch);
}